import React, { Component } from "react";
import YouTube from "react-youtube";
import { Pannellum } from "pannellum-react";

import "reactjs-popup/dist/index.css";
import "./PopUpContents.css";
import AppConsts from "../Constants/AppConsts.json";
import Images from "../Theme/Images";

export default class PopUpContents extends Component {
  onClickOption = (iteration) => {
    this.props.onRequestClosePopUp();
    const { currentPath } = this.props;
    switch (iteration) {
      case 0:
        this.props.history.push(`${currentPath}/2021/university/explore`);
        break;
      case 1:
        this.props.history.push(
          `${currentPath}/2021/faculty/explore/floor/basement`
        );
        break;
      case 2:
        this.props.history.push(
          `${currentPath}/2021/faculty/explore/floor/ground`
        );
        break;
      case 3:
        this.props.history.push(
          `${currentPath}/2021/faculty/explore/floor/first`
        );
        break;
      case 4:
        this.props.history.push(
          `${currentPath}/2021/faculty/explore/floor/second`
        );
        break;
      default:
        break;
    }
  };

  returnContent = (content) => {
    if (content.isVideo) {
      return (
        <YouTube
          videoId={content.youtubeID}
          opts={PageConstants.Youtube}
          containerClassName="youtubeContainer"
        />
      );
    }
    return (
      <Pannellum
        width="100%"
        height="400px"
        image={Images[content.panoramicImageName]}
        pitch={10}
        yaw={content.panoramicImageYaw}
        hfov={110}
        autoLoad
        autoRotate={-5}
        title="This is a 360° interactive image."
        onLoad={() => {
          console.log("panorama loaded");
        }}
      />
    );
  };

  render() {
    const { currentLocation, isContentAvailable } = this.props;
    const content = isContentAvailable ? (
      <div className="popup-body">
        <header className="popup-header">{currentLocation.title}</header>
        {currentLocation.description ? (
          <h3>{currentLocation.description}</h3>
        ) : null}
        {currentLocation.isVideo ? (
          <p className="popup-body-text">
            If this video is not playing, please use another browser (e.g.:
            Firefox).
          </p>
        ) : null}
        {this.returnContent(currentLocation)}
        {currentLocation.usedGoogle ? <h5>{AppConsts.disclaimer}</h5> : null}
      </div>
    ) : (
      <div className="popup-body">
        <header className="popup-header">{AppConsts.type_selection}</header>
        {Array(5)
          .fill()
          .map((_, i) => i)
          .map((i) => (
            <button
              key={i}
              onClick={() => this.onClickOption(i)}
              className="myButton"
            >
              {AppConsts.types[i]}
            </button>
          ))}
      </div>
    );
    return content;
  }
}

const PageConstants = {
  Youtube: {
    playerVars: {
      autoplay: 1,
    },
  },
};
